<template>
  <path d="M19 0h-14c-2.76 0-5 2.239-5 5v14c0 2.76 2.239 5 5 5h14c2.759 0 5-2.239 5-5v-14c0-2.76-2.239-5-5-5m0 2c1.66 0 3 1.345 3 3v14c0 1.654-1.338 3-3 3h-14c-1.654 0-3-1.339-3-3v-14c0-1.658 1.342-3 3-3h14z"/>
</template>

<script>
export default {
  name: 'IconSquare'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/IconSquare.vue